import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import Flag from 'tradera/components/flag/flag';
import { isSwedenCountryCodeOrUndefined } from 'tradera/localization/countrycode';
import LocalizedPrice from 'tradera/localization/localized-price';
import { getDisplayText } from 'tradera/apps/tradera/components/vip-shared/shipping-options/shipping-options';
import styles from './bin-modal-shipping-display.module.scss';
import cn from 'classnames';

export const ShippingDisplay = ({
    buyerCountryCode,
    shippingOptions,
    shippingPriceRange,
    isSellpyCheckout
}) => {
    const { t } = useTranslator();

    const isFromAndToCountryDifferent = shippingOptions.some(
        ({ fromCountryCodeIso2, toCountryCodeIso2 }) =>
            fromCountryCodeIso2 !== toCountryCodeIso2
    );
    let displayOptions = shippingOptions;
    if (buyerCountryCode !== undefined && isFromAndToCountryDifferent) {
        displayOptions = displayOptions.filter(
            (option) => option.toCountryCodeIso2 === buyerCountryCode
        );
    }

    const shippingOptionsPart = (
        <div className={cn('d-flex flex-column', styles.shipping)}>
            {!shippingPriceRange &&
                displayOptions.map((shippingOption, index) => {
                    const description = getDisplayText(shippingOption, t);
                    const shouldShowFromCountry =
                        !isSwedenCountryCodeOrUndefined(
                            shippingOption.fromCountryCodeIso2
                        ) &&
                        shippingOption.fromCountryCodeIso2 !==
                            shippingOption.toCountryCodeIso2;
                    return (
                        <div
                            key={index + description + shippingOption.cost}
                            className="d-flex align-items-center">
                            {shouldShowFromCountry && (
                                <Flag
                                    className="icon icon-lg mr-1 align-middle"
                                    countryCodeIso2={
                                        shippingOption.fromCountryCodeIso2
                                    }
                                />
                            )}
                            <div className="flex-grow-1 mr-4">
                                {description}
                            </div>
                            <div className="ml-2 text-right font-weight-bold">
                                <LocalizedPrice
                                    tagName="div"
                                    renderZero
                                    price={shippingOption.cost}
                                />
                            </div>
                        </div>
                    );
                })}
            {shippingPriceRange && (
                <div>
                    <div className="font-weight-bold text-right mb-2 mb-md-0 w-100">
                        {t('checkout_shipping_priceRange', {
                            min: shippingPriceRange.minPrice,
                            max: shippingPriceRange.maxPrice
                        })}
                    </div>
                    {isSellpyCheckout && (
                        <div className="font-italic text-right w-100 mb-2 mb-md-0 mt-md-2">
                            {t('cart_sellpyShippingRange')}
                        </div>
                    )}
                </div>
            )}
        </div>
    );

    return (
        <div
            className={cn('d-lg-flex', {
                'd-flex flex-row pb-0 pb-md-2': shippingPriceRange,
                'pb-2': !shippingPriceRange
            })}>
            <p className="text-styled flex-grow-1 mb-0">
                {shippingPriceRange
                    ? t('checkout_bin_shippingPriceRange')
                    : t('checkout_bin_shippingOptions')}
            </p>
            {shippingOptionsPart}
        </div>
    );
};
